import React, { useRef, useState } from "react";
import classNames from "classnames/bind";
import { DateTimeIcon } from "../Icons/Icons";
import styles from "./DateTimePicker.module.css";
import { formatDDMMYY, formatDates } from "../../utils";
import "react-calendar/dist/Calendar.css";

import Calendar from "react-calendar";
import useDetectElement from "../../hooks/useDetectElement";
const cx = classNames.bind(styles);
const DateTimePicker = ({
  title,
  disabled,
  value,
  size = "small",
  onChange,
  styles,
  className,
}) => {
  const ref = useRef();
  const refDiv = useRef();
  const [time, setTime] = useState(value);
  const [show, setShow] = useState(false);
  const data = useDetectElement(ref);
  useState(() => {
    if (!value) {
      const dateNow = new Date();
      setTime(dateNow);
    }
  }, [value]);
  React.useEffect(() => {
    let handler = (e) => {
      if (
        !ref?.current?.contains(e.target) &&
        !refDiv?.current?.contains(e.target)
      ) {
        setShow(false);
      }
      else {
        setShow(true)
      }
    };

    document.addEventListener("click", handler);

    return () => {
      document.removeEventListener("click", handler);
    };
  }, []);
  const events = ["03-05-2023", "04-05-2023", "05-05-2023"];
  return (
    <div

      style={{ ...styles }}
      className={cx("form-control")}
    >
      <label className={cx("title")}>{title}</label>
      <div
        ref={refDiv}
        style={{
          height: 36,
          border: "1px solid #ccc",
          width: '100%',
          display: "flex",
          alignItems: "center",
          marginTop: 4,
          borderRadius: 4,
        }}
      >
        {" "}
        <span className={cx(`${size === "small" ? "icon-small-c" : "icon"}`)} style={{ top: 'auto' }}>
          <DateTimeIcon />
        </span>
        <span className={cx("value")}>{formatDDMMYY(time)}</span>
      </div>
      {show && (
        <div ref={ref}>
          <Calendar
            value={time}
            onChange={(value, e) => {
              setTime(value);
              onChange(value);
              setShow(false)
            }}
            className={cx("dateTime")}
            
          />
        </div>
      )}
    </div>
  );
};

export default DateTimePicker;
